import styled from "styled-components";

import Background from "../../images/background.png";

export const Container = styled.section`
  display: flex;
  justify-content: center;
  background-image: url(${Background});
  background-repeat: no-repeat;
  background-size: cover;
  padding: 50px 20px;
  border-bottom: 5px solid #139ed5;
`;

export const Content = styled.div`
  max-width: 1262px;
  width: 100%;

  h1 {
    text-align: center;
    color: #f8f6f5;
    font-size: 36px;
    font-family: "Noto Serif";
    margin-bottom: 120px;
  }

  @media (max-width: 560px) {
    h1 {
      margin-bottom: 0px;
    }
  }
`;

export const Cards = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;

  div:nth-child(4),
  div:last-child {
    margin-top: 100px;
    margin-left: 50%;
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);

    div:nth-child(3),
    div:nth-child(4) {
      margin-top: 100px;
    }

    div:nth-child(4),
    div:last-child {
      margin-left: 0%;
    }
  }

  @media (max-width: 560px) {
    display: flex;
    flex-direction: column;
    align-items: center;

    div {
      margin-top: 100px;
    }
  }
`;
